import React from "react";
import classes from "./styles.module.scss";
import classNames from "classnames";

let searchReferrer: string | undefined;
if (document.referrer) {
   const referrerUrl = new URL(document.referrer);
   if (referrerUrl.origin == document.location.origin && referrerUrl.pathname.toLowerCase().startsWith("/search")) {
      searchReferrer = document.referrer;
   }
}

interface NotifyFormConfirmationProps {
   citySearchUrl?: string;
}

const NotifyFormConfirmation: React.FC<NotifyFormConfirmationProps> = ({ citySearchUrl }) => <div className={classes.container}>
   <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" fill="none" className={classes.icon}>
      <path fill="#BADF93" fillOpacity=".4" d="M50.869 5.922a16.781 16.781 0 0 1 18.262 0 16.781 16.781 0 0 0 10 2.68 16.781 16.781 0 0 1 15.816 9.13 16.782 16.782 0 0 0 7.32 7.321 16.78 16.78 0 0 1 9.131 15.816 16.779 16.779 0 0 0 2.68 10 16.783 16.783 0 0 1 0 18.262 16.779 16.779 0 0 0-2.68 10 16.78 16.78 0 0 1-9.131 15.816 16.782 16.782 0 0 0-7.32 7.32 16.78 16.78 0 0 1-15.816 9.131 16.779 16.779 0 0 0-10 2.68 16.783 16.783 0 0 1-18.262 0 16.779 16.779 0 0 0-10-2.68 16.78 16.78 0 0 1-15.816-9.131 16.782 16.782 0 0 0-7.32-7.32A16.781 16.781 0 0 1 8.602 79.13a16.781 16.781 0 0 0-2.68-10 16.781 16.781 0 0 1 0-18.262 16.781 16.781 0 0 0 2.68-10 16.781 16.781 0 0 1 9.13-15.816 16.782 16.782 0 0 0 7.321-7.32A16.781 16.781 0 0 1 40.87 8.602a16.781 16.781 0 0 0 10-2.68Z" />
      <circle cx="60" cy="60" r="45" fill="#BADF93" />
      <path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="8" d="M77.667 49.5 54.75 72.417 44.333 62" />
   </svg>
   <div className={classes.title}>
      Your request
      <br />
      has been submitted
   </div>
   <div className={classes.subtitle}>
      Our team will reach out when your
      <br />
      location has been added
   </div>
   <a href={searchReferrer ?? citySearchUrl} className={classNames("btn btn-primary", classes.button)}>
      View other spaces
   </a>
</div>;

export default NotifyFormConfirmation;